import { get, post } from "../../helpers/utils/http-client";
import { CONFIGS_ENDPOINT } from '../../consts/api-endpoints';

export async function getConfig(type, configName, accessKey) {
    try {
        const resp = await get(`${CONFIGS_ENDPOINT}/${type}/${configName}`, {} ,{ 'Authorization': accessKey });
        const { response, status } = resp;
        if (status !== 200) {
            return {};
        }
        return response;
    } catch (err) {
        console.debug('getConfig failed cause', err.message, err.code);
        return {};
    }
}